
import  axios  from 'axios';


export const LOAD_CCTRANSACTION_DATA = 'cctransaction/LOAD_CCTRANSACTION_DATA';
export const DELETE_A_CCTRANSACTION = 'cctransaction/DELETE_A_CCTRANSACTION';
export const SAVE_A_CCTRANSACTION = 'cctransaction/SAVE_A_CCTRANSACTION';
export const UPDATE_A_CCTRANSACTION = 'cctransaction/UPDATE_A_CCTRANSACTION';


export function loadCctransactionDataInStore(argCctransactionDataArray) {
    return {
        type: LOAD_CCTRANSACTION_DATA,
        cctransactionsData:argCctransactionDataArray
    }
}
export function deleteACctransactionDataInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_CCTRANSACTION,
        deleteCctransactionResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveACctransactionDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_CCTRANSACTION,
        saveCctransactionResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateACctransactionDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_CCTRANSACTION,
        updateCctransactionResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

/********************* End of InStore calls **************************/

//****************************************
//Below is for update a Stream
//****************************************
export function updateACctransaction(argURL, argCamera) {
    return (dispatch, getState) => {

        updateACctransactionOnServer(argURL, argCamera).then(function(saveResponse){

            dispatch(saveACctransactionDataInStore(saveResponse, {}));

        }, function(err){
            console.log("I had an error saving a cctransaction" + err.response.data);
            dispatch(saveACctransactionDataInStore({}, err.response.data));
        });
    }//end of return
}


function updateACctransactionOnServer( argURL, argCamera){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateACctransaction(argURL, argCamera)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on saving a cctransactions " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateACctransaction(argURL, argCamera ){
    /*
     I build something like this :
     http://localhost:4567/cctransactions
     */

    let baseUrl = argURL+"cctransactions";
    console.log(" on posting a cctransactionies the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argCamera ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveACctransaction(argURL, argCamera) {
    return (dispatch, getState) => {

        saveACctransactionOnServer(argURL, argCamera).then(function(saveResponse){

            dispatch(saveACctransactionDataInStore(saveResponse, {}));

        }, function(err){
            console.log("I had an error saving a cctransaction" + err.response.data);
            dispatch(saveACctransactionDataInStore({}, err.response.data));
        });
    }//end of return
}


function saveACctransactionOnServer( argURL, argCamera){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveACctransaction(argURL, argCamera)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on saving a cctransactions " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveACctransaction(argURL, argCamera ){
    /*
     I build something like this :
     http://localhost:4567/cctransactions
     */

    let baseUrl = argURL+"cctransactions";
    console.log(" on posting a cctransactionies the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCamera ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a cctransaction
//****************************************
export function deleteACctransaction(argURL, argCameraId) {
    return (dispatch, getState) => {

        deleteACctransactionOnServer(argURL, argCameraId).then(function(deleteResponse){

            dispatch(deleteACctransactionDataInStore(deleteResponse, null));

        }, function(err){
            console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteACctransactionDataInStore({}, err));
        });
    }//end of return
}


function deleteACctransactionOnServer( argURL, argStreamId){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteACctransaction(argURL, argStreamId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on deleteing a cctransaction " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteACctransaction(argURL, argStreamId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */

    let baseUrl = argURL+"cctransactions"+"/"+argStreamId;
    console.log(" on deleteing a cctransaction the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl));
    }
    return arrayOfGets;
}


//Get list of cctransactions

export function loadCctransactionsData(argURL) {
    return (dispatch, getState) => {

        getListOfCctransactions(argURL).then(function(cctransactionsList){

            dispatch(loadCctransactionDataInStore(cctransactionsList));

    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}

function getArrayOfGetsForListOfCctransactions(argURL ){
    /*
     I build something like this :
     http://localhost:4567/cctransaction
     */

    let baseUrl = argURL+"cctransactions";
    console.log(" on getting list of Cctransactions  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl));
    }
    return arrayOfGets;
}

function getListOfCctransactions( argURL){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfCctransactions(argURL)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Cctransactions " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}


function getCctransactionDataFromRemoteServer( argURL, argCctransactionsList  ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if(argCctransactionsList != null){

            axios.all(getArrayOfGets(argURL, argCctransactionsList )).then(function(responses){
                resolve(responses);

            }, function(err) {
                console.log("Farshid some error occured " + err.message);
                reject(err);
            });
        }
    });

    return returnPromise;
}

function getArrayOfGets(argURL, argFarmsList ){

    //let baseUrl =  "http://innovasea-app-dev-1.eastus.cloudapp.azure.com:4567/METRIC_VALUES?";
    let baseUrl = argURL;

    /*

     I need to build something like this :

     http://innovasea-app-dev-1.eastus.cloudapp.azure.com:4567/GRAPHS/farm_summary?farmId=f1
     */

    var arrayOfGets = [];
    if(argFarmsList != null) {
        for (var i = 0; i < argFarmsList.length; i++) {
                let responseData = argFarmsList[i];
                //let responseData = singleResponse.data;
                //if((argMetricList[i].checked != null) && (argMetricList[i].checked == true) ) {
                let tempURl = baseUrl + "GRAPHS" + "/farm_summary?farmId=" + responseData.id;
                console.log("Farshid the Cctransaction DATA URL is =" + tempURl);
                arrayOfGets.push(axios.get(tempURl));

            //}
        }
    }
    return arrayOfGets;


}

/*
export function loadCctransactionData(argURL) {
    return (dispatch, getState) => {


        var arrayOfCctransactionData=[];
        getListOfCctransactions(argURL).then(function(cctransactionsList){

            for(var z=0; z<cctransactionsList.length; z++){

                let singleResponse = cctransactionsList[z];
                let responseData = singleResponse.data;
                getCctransactionDataFromRemoteServer(argURL,responseData ).then(function (farmsData){
                    for(var i=0; i<farmsData.length; i++) {
                        arrayOfCctransactionData.push(farmsData[i].data);
                    }
                    dispatch(loadCctransactionDataInStore(arrayOfCctransactionData));

                }, function (err){
                    console.log("I had an error gettting Farms Data3333" + err);
                });

            }
    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}
 */